import Home from '../components/HelloFromVux.vue'
//首页路由
const index = [
    {
        path: '/',
        component: () => import('@/views/index/index.vue')
    },{
        name:'index',
        path: '/index',
        component: () => import('@/views/index/index.vue')

    },{
        name:'xxxly',
        path: '/xxxly',
        component: () => import('@/views/childClass/xxxly.vue')

    },{
        name:'ngqj',
        path: '/ngqj',
        component: () => import('@/views/childClass/ngqj.vue')

    },{
        name:'childclass',
        path: '/childclass',
        component: () => import('@/views/childClass/childClass.vue')

    },{
        name:'arcticleInfo',
        path: '/arcticleInfo',
        component: () => import('@/views/arcticleInfo/arcticleInfo.vue')

    },{
        name:'xxxlyDetail',
        path: '/xxxlyDetail',
        component: () => import('@/views/arcticleInfo/xxxlyDetail.vue')

    },{
        name:'hdxl',
        path: '/hdxl',
        component: () => import('@/views/hdxl/hdxl.vue')

    },{
        name:'hdxlinfo',
        path: '/hdxlinfo',
        component: () => import('@/views/hdxlinfo/hdxlinfo.vue')

    },{
        name:'expertsAnswer',
        path: '/expertsAnswer',
        component: () => import('@/views/expertsAnswer/expertsAnswer.vue')

    },{
        name:'experts',
        path: '/experts',
        component: () => import('@/views/experts/experts.vue')

    },{
        name:'user',
        path: '/user',
        component: () => import('@/views/user/user.vue')

    },{
        name:'serachResult',
        path: '/serachResult',
        component: () => import('@/views/serachResult/serachResult.vue')

    },{
        name:'submit',
        path: '/submit',
        component: () => import('@/views/submit/submit.vue')

    },{
        name:'login',
        path: '/login',
        component: () => import('@/views/login/login.vue')

    },{
        name:'xmjs',
        path: '/xmjs',
        component: () => import('@/views/xmjs/xmjs.vue')

    },{
        name:'mobileArcticle',
        path: '/mobileArcticle',
        component: () => import('@/views/mobileArcticle/mobileArcticle.vue')

    },{
        name:'mobileXxxly',
        path: '/mobileXxxly',
        component: () => import('@/views/mobileArcticle/mobileXxxly.vue')

    }	
    	
];


export default [
    ...index
]    



// WEBPACK FOOTER //
// ./src/router/index.js